"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var browser_core_1 = require("@datadog/browser-core");
var lifeCycle_1 = require("./lifeCycle");
exports.RUM_SESSION_KEY = 'rum';
var RumTrackingType;
(function (RumTrackingType) {
    RumTrackingType["NOT_TRACKED"] = "0";
    RumTrackingType["TRACKED_WITH_RESOURCES"] = "1";
    RumTrackingType["TRACKED_WITHOUT_RESOURCES"] = "2";
})(RumTrackingType = exports.RumTrackingType || (exports.RumTrackingType = {}));
function startRumSession(configuration, lifeCycle) {
    var session = browser_core_1.startSessionManagement(exports.RUM_SESSION_KEY, function (rawTrackingType) {
        return computeSessionState(configuration, rawTrackingType);
    });
    session.renewObservable.subscribe(function () {
        lifeCycle.notify(lifeCycle_1.LifeCycleEventType.SESSION_RENEWED);
    });
    return {
        getId: session.getId,
        isTracked: function () { return session.getId() !== undefined && isTracked(session.getTrackingType()); },
        isTrackedWithResource: function () {
            return session.getId() !== undefined && session.getTrackingType() === RumTrackingType.TRACKED_WITH_RESOURCES;
        },
    };
}
exports.startRumSession = startRumSession;
function computeSessionState(configuration, rawTrackingType) {
    var trackingType;
    if (hasValidRumSession(rawTrackingType)) {
        trackingType = rawTrackingType;
    }
    else if (!browser_core_1.performDraw(configuration.sampleRate)) {
        trackingType = RumTrackingType.NOT_TRACKED;
    }
    else if (!browser_core_1.performDraw(configuration.resourceSampleRate)) {
        trackingType = RumTrackingType.TRACKED_WITHOUT_RESOURCES;
    }
    else {
        trackingType = RumTrackingType.TRACKED_WITH_RESOURCES;
    }
    return {
        trackingType: trackingType,
        isTracked: isTracked(trackingType),
    };
}
function hasValidRumSession(trackingType) {
    return (trackingType === RumTrackingType.NOT_TRACKED ||
        trackingType === RumTrackingType.TRACKED_WITH_RESOURCES ||
        trackingType === RumTrackingType.TRACKED_WITHOUT_RESOURCES);
}
function isTracked(rumSessionType) {
    return (rumSessionType === RumTrackingType.TRACKED_WITH_RESOURCES ||
        rumSessionType === RumTrackingType.TRACKED_WITHOUT_RESOURCES);
}
//# sourceMappingURL=rumSession.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@datadog/browser-rum/cjs/rumSession.js
// module id = 762
// module chunks = 0